import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LazyLoadEvent } from "../../models/DataTables/lazyLoadEvent";
import { CreateTeamForUserModel, EditTeamModel, Team } from "../../models/inModels/Team";
import { AuthenticationService } from "../authentication/authentication.service";
import { LoggingService } from "../logging/logging.service";


@Injectable()
export class TeamsService {
	private routeCategory = '/api/teams';
	constructor(
		private http: HttpClient,
		private auth: AuthenticationService,
		private logging: LoggingService) { }

	search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/search`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	get(id: number): Promise<Team> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as Team)
			.catch(error => this.logging.handleError(error));
	}

	create(user: CreateTeamForUserModel): Promise<Team> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/create/user`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as Team)
			.catch(error => this.logging.handleError(error));
	}

	update(user: EditTeamModel): Promise<Team> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/update`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as Team)
			.catch(error => this.logging.handleError(error));
	}

	delete(id: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
}



// WEBPACK FOOTER //
// ./src/app/services/teams/team.service.ts